import { use_auth } from "@/auth/useAuth";
import LoginView from "@/views/LoginView.vue";
import NotFound from "@/views/NotFound.vue";
import DefaultContainer from "@/views/DefaultContainer.vue";
import NetworkTopology from "@/components/ClientDetail/nmap/NetworkTopology.vue";
import { createRouter, createWebHistory } from "vue-router";
import { client_routes } from "./client";
import { campaign_routes } from "./campaign";
import { userRoutes } from "./user";
import { version_routes } from "./version";
import { files_routes } from "./files";

const routes = [
  {
    path: "/login",
    component: LoginView,
    name: "Login",
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
  },
  {
    path: "/",
    component: DefaultContainer,
    children: [
      {
        path: "/",
        component: () => {
          router.push({
            name: "ClientList",
          });
        },
      },
      client_routes,
      version_routes,
      campaign_routes,
      userRoutes,
      files_routes,
      {
        path: "network-topology/:action_id",
        component: NetworkTopology,
        name: "NetworkTopology",
      },
    ],
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from) => {
  const auth = use_auth();

  // Validate session at most once per TTL; protected API 401s are refreshed centrally.
  if (auth.isLoggedIn && auth.fetchMeThrottled) {
    await auth.fetchMeThrottled();
  }

  if (!auth.isLoggedIn && to.name !== "Login" && to.name !== "NetworkTopology")
    return {
      name: "Login",
    };

  if (auth.isLoggedIn && to.name === "Login")
    return (
      from ?? {
        name: "ClientList",
      }
    );

  if (to.path.startsWith("/user") && auth.isLoggedIn && !auth.isAdmin)
    return {
      name: "ClientList",
    };
});
